module.exports = __webpack_public_path__ + "img/payment_channels_active.7f5d4f22.svg";